import { Flex } from 'antd'
import Image from '@/components/image'
import styles from './style.module.scss'

export default function Spec({ images }: { images: string[] }) {
  return (
    <div className={styles.spec}>
      <h2>Product Specification</h2>
      <Flex vertical className={styles.specImages}>
        {images.map(image => (
          <Image key={image} src={image} alt='spec' className={styles.specImages} />
        ))}
      </Flex>
    </div>
  )
}
